var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4472 18.2068C12.525 18.0168 13.5547 17.6163 14.4777 17.0283C15.4006 16.4404 16.1987 15.6763 16.8264 14.7799C17.4541 13.8834 17.8991 12.8722 18.136 11.8037C18.3728 10.7353 18.3969 9.63074 18.2069 8.55301C18.0169 7.47529 17.6164 6.44555 17.0284 5.52258C16.4404 4.59962 15.6764 3.80151 14.78 3.17381C13.8835 2.54612 12.8722 2.10114 11.8038 1.86428C10.7354 1.62742 9.63082 1.60332 8.55309 1.79335C7.47537 1.98338 6.44563 2.38383 5.52266 2.97182C4.5997 3.55981 3.80159 4.32384 3.17389 5.22028C2.5462 6.11672 2.10122 7.12801 1.86436 8.19642C1.6275 9.26483 1.6034 10.3694 1.79343 11.4472C1.98346 12.5249 2.38391 13.5546 2.9719 14.4776C3.55989 15.4005 4.32392 16.1987 5.22036 16.8264C6.1168 17.454 7.12809 17.899 8.1965 18.1359C9.26491 18.3727 10.3695 18.3968 11.4472 18.2068L11.4472 18.2068Z",
    stroke: "#7161BA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L10 15",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83325L10 4.99992",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.267b42a68d4e26425c882c5ec723d8c1.svg";
export { ForwardRef as ReactComponent };